export default __webpack_public_path__ + "static/media/recaptcha.7f7ba1e6.svg";